import styles from 'components/icons/Icon.module.scss';
import { IconProps } from 'components/icons/Icons.types';
import React from 'react';

const GlassIcon: React.FC<IconProps> = ({
  className = '',
  size = 24,
  color = '#fffff0',
  fillColor = 'transparent',
  fillOpacity = 1,
  circleStrokeColor = 'transparent',
}) => {
  const baseCls = `${styles.IconContainer} ${className}`;
  return (
    <div className={baseCls}>
      <svg width={size} height={size} viewBox="0 0 24 24" fill="transparent" xmlns="http://www.w3.org/2000/svg">
        <circle
          fill={fillColor}
          fillOpacity={fillOpacity}
          cx="12"
          cy="12"
          r="10.5"
          stroke={circleStrokeColor}
          strokeWidth={'1.5px'}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17 10C17 12.419 15.2822 14.4367 13 14.9V17H15V19H9V17H11V14.9C8.71776 14.4367 7 12.419 7 10V5H17V10ZM15 7H9V10C9 11.6569 10.3431 13 12 13C13.6569 13 15 11.6569 15 10V7Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

export default GlassIcon;
